/* eslint-disable no-trailing-spaces */

import React from 'react';
import { Footer, Header, Experience, Skills, Work } from './container';
import { Navbar } from './components';
import { ChatProvider } from './context/ChatContext';
// import VGPTChat from './components/VGPTChat/VGPTChat'; // hidden for now, re-enable later
import './App.scss';

const App = () => (
  <ChatProvider>
    <div className="app">
      <Navbar />
      <Header />
      <Work />
      <Experience />
      <Skills />
      <Footer />
      {/* <VGPTChat /> */}
    </div>
  </ChatProvider>
);

export default App;
